import React, { useCallback } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { userAdminHandler } from "../../redux/handlers";
import { useGlobalTable } from "../../hooks/useGlobalTable";
import { AllderTable } from "../../components/AllderTable";
import { createTableColumns } from "../../utils/createTableColumns";

export function UserAdminManagement() {
  const dispatch = useDispatch();

  const fetchUserData = useCallback(
    (params) => dispatch(userAdminHandler.getUserAdmins(params)),
    [dispatch]
  );

  const {
    data: userData,
    loading,
    totalRows,
    paginationModel,
    setPaginationModel,
    handleSort,
    debouncedSearch,    
    filterParams,
  } = useGlobalTable({
    fetchData: fetchUserData,
    defaultSort: "created_at",
    defaultOrder: "desc",
    defaultPageSize: 20,
  });

  const handleExport = () => {
    dispatch(userAdminHandler.exportUserAdminToExcel(filterParams?.s));
  };

  const columns = createTableColumns([
    {
      field: "code",
      headerName: "รหัส ADMIN",
      width: 140,
      sortable: true,
      renderCell: ({ row }) => (
        <Link
          to={`/setting/user/manage/${row.id}`}
          className="text-[#2DC76D] underline"
        >
          {row.code}
        </Link>
      ),
    },
    {
      field: "fullName",
      headerName: "ชื่อพนักงาน (ชื่อเล่น)",
      width: 280,
      flex: 1,
      minWidth: 280,
      sortable: false,
      renderCell: ({ row }) => (
        <div>
          {`${row.prefixName.name} ${row.first_name} ${row.last_name}`} (
          {row.nickname})
        </div>
      ),
    },
    {
      field: "permission",
      headerName: "ระดับสิทธิ์",
      width: 180,
      sortable: false,
      renderCell: ({ row }) => (
        <div className="text-[#FF3B30] text-center p-2 w-[160px] rounded bg-[#FFEEEE]">
          ADMIN SYSTEM
        </div>
      ),
    },
    // {
    //   field: "phone_number",
    //   headerName: "เบอร์โทร",
    //   width: 180,
    //   sortable: false,
    // },
    {
      field: "email",
      headerName: "E-mail",
      width: 240,
      sortable: false,
    },
    {
      field: "actions",
      headerName: "จัดการ",
      width: 100,
      sortable: false,
      renderCell: ({ row }) => (
        <div>
          <Link
            to={`/setting/user/manage/${row.id}`}
            type="button"
            className="btn-edit-st-1"
          />
        </div>
      ),
    },
  ]);

  return (
    <div>
      <nav aria-label="breadcrumb" className="mt-2">
        <ol className="breadcrumb fs-16 ps-0">
          <li className="breadcrumb-item">
            <Link to="/setting" className="tc-7 text-decoration-none">
              ตั้งค่า
            </Link>
          </li>
          <li className="breadcrumb-item active tc-1" aria-current="page">
            จัดการข้อมูลผู้ใช้งาน
          </li>
        </ol>
      </nav>

      <div className="card card-st-2">
        <div className="card-body px-0 py-4">
          <div className="text-xl tc-7 px-4 mb-4 lh-1">
            จัดการข้อมูลผู้ใช้งาน
          </div>
          <div className="d-flex align-items-center px-4 mb-4">
            <button
              className="btn btn-export-st-1 me-auto"
              onClick={handleExport}
            >
              Export
            </button>
            <div className="me-3">
              <input
                type="text"
                className="form-control form-st-4"
                placeholder="ค้นหาชื่อ"
                onChange={(e) => debouncedSearch(e.target.value)}
              />
            </div>
            <Link
              to="/setting/user/manage"
              type="button"
              className="btn btn-st-7"
            >
              เพิ่มผู้ใช้งาน
            </Link>
          </div>

          <AllderTable
            data={userData}
            loading={loading}
            columns={columns}
            totalRows={totalRows}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            handleSort={handleSort}
          />
        </div>
      </div>
    </div>
  );
}
